import React from 'react';
import { ReactComponent as DotIcon } from '@/img/button-dot.svg';
import { ReactComponent as CloseIcon } from '@/img/button-close.svg';
import { ReactComponent as ExpandIcon } from '@/img/icon-arrows-expand.svg';
import { ReactComponent as CollapseIcon } from '@/img/icon-arrows-colapse.svg';
import './UIIconExtraButton.scss';

export type UIIconExtraType = 'dot' | 'close' | 'expand' | 'collapse';

export interface UIIconExtraButtonProps {
  /**
   * Тип іконки
   */
  icon: UIIconExtraType;

  /**
   * Обробник кліку
   */
  onClick?: () => void;

  /**
   * Вимкнена кнопка
   */
  disabled?: boolean;

  /**
   * Додатковий CSS клас
   */
  className?: string;

  /**
   * Атрибут aria-label для доступності
   */
  ariaLabel?: string;

  /**
   * Підказка при hover
   */
  title?: string;
}

// Мапа іконок
const iconMap: Record<UIIconExtraType, React.ComponentType> = {
  dot: DotIcon,
  close: CloseIcon,
  expand: ExpandIcon,
  collapse: CollapseIcon,
};

// Моковые данные для демонстрації
const mockProps: UIIconExtraButtonProps = {
  icon: 'dot',
  onClick: () => console.log('Extra icon button clicked'),
  disabled: false,
  ariaLabel: 'Extra button',
};

const baseClass = 'UIIconExtraButton';

const UIIconExtraButton: React.FC<UIIconExtraButtonProps> = ({
                                                               icon = mockProps.icon,
                                                               onClick = mockProps.onClick,
                                                               disabled = mockProps.disabled,
                                                               className = '',
                                                               ariaLabel,
                                                               title,
                                                             }) => {
  const buttonClasses = [
    baseClass,
    `${baseClass}--${icon}`,
    disabled && `${baseClass}--disabled`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  // Функція для вибору правильної іконки
  const renderIcon = () => {
    const IconComponent = iconMap[icon];
    return IconComponent ? <IconComponent /> : null;
  };

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <button
      type="button"
      className={buttonClasses}
      onClick={handleClick}
      disabled={disabled}
      aria-label={ariaLabel || `${icon} button`}
      title={title}
    >
      <span className={`${baseClass}__icon`}>
        {renderIcon()}
      </span>
    </button>
  );
};

export default UIIconExtraButton;